import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullsafe } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.FiltroRutaEntregaDomicilio;

export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
}

/**
* Valida un Entity
*/
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = { };
    return validation.getErrors(rules, x);
}

/**
* Componente para editar un Entity
*/
export class FiltroComponent extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Number = getField(kea.Number);
        const Sucursal = getField(selectores.Sucursal);
        return (
            <div>
                {kea.autogrid(3, [
                    <Sucursal field="IdSucursal" label="Sucursal" />,
                    <Number field="CodigoPostal" label="Código postal" />
                ])}
            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/rutaEAD/list/filtro.tsx